

import React, { memo, useState } from 'react';
import cx from 'classnames';
import { EditorState } from 'draft-js';
import { getCostValue } from '@shootsta/cost-parsing-utils';
import { Input, Button, Icon, LucideIcon } from '../../../../ui-kit';
import { Trash2 } from 'lucide-react';
import RichTextEditor from '../../../RichTextEditor/components/RichTextEditor';
import AspectRatio from '../../../Addons/components/Dropdown/AspectRatio';
import NewOutput from '../NewOutput';
import EditCost from '../../../Addons/components/Expandable/common/EditCost/components/EditCost';

import '../../styles/_social-iteration.scss';


























const ASPECT_RATIO_ROTATE_MAP = {
  WIDE: { rotated: true },
  SQUARE: { rotated: true },
  INSTA: { rotated: false },
  STANDARD: { rotated: true }
};


function SocialIteration({
  outputIndex,
  aspectRatio,
  onChangeAddon,
  notes,
  outputId,
  onNotesChange,
  name,
  updateOutputName,
  createNewOutput,
  deleteOutput,
  canUpdateVideo,
  canUpdateMaster,
  getCurrencySymbol,
  getCurrencyIcon,
  isLastOutput,
  onChangeCost,
  output,
  editingMode,
  isMobile,
  isPodcast
}) {
  const { rotated } = ASPECT_RATIO_ROTATE_MAP[aspectRatio];

  const [outputNotes, setOutputNotes] = useState(notes);

  const handleOutputNotesChange = (editorState) => {
    setOutputNotes(editorState);
  };

  return (
    <div className={cx('social-iteration', { mobile: isMobile })}>
      <div className="social-iteration__preview-container">
        {!isPodcast &&
        <div
          className={cx(
            'social-iteration__preview',
            `social-iteration__preview--${aspectRatio}`,
            { 'social-iteration__preview--rotated': rotated }
          )}>

            <Icon name="aspectshell" size={180} />
            <Icon name="video" size={30} color="white" />
          </div>}

        {editingMode &&
        <EditCost
          cost={getCostValue(output, 'outputCost')}
          getCurrencySymbol={getCurrencySymbol}
          getCurrencyIcon={getCurrencyIcon}
          onChangeCost={onChangeCost} />}


      </div>
      <div className="social-iteration__configure">
        <div className="social-iteration__configure__header">
          <div className="social-iteration__configure__header__fields">
            {!isPodcast &&
            <AspectRatio
              onChangeAddon={onChangeAddon}
              aspectRatio={aspectRatio}
              label="Select Ratio"
              disabled={!canUpdateMaster} />}


            <Input
              label="Iteration Name"
              placeholder="Iteration name"
              defaultValue={name || `Iteration ${outputIndex + 1}`}
              onChange={updateOutputName(outputId)}
              disabled={!canUpdateMaster} />

          </div>
          {!isMobile &&
          <Button
            prefix={<LucideIcon icon={Trash2} size={20} />}
            onClick={deleteOutput}
            type="TERTIARY"
            disabled={!canUpdateMaster}
            className="remove-iteration" />}


        </div>
        <div className="social-iteration__configure--editor-brief-section-notes">
          <RichTextEditor
            label="Social Iteration Brief"
            editorState={outputNotes}
            onUpdateContent={handleOutputNotesChange}
            placeholder={canUpdateMaster ?
            `Provide your Video Editor with essential information like:
  - Video type
  - Target audience
  - Music & video style references
  - Key message
  - etc` :
            'Notes'}
            disabled={!canUpdateMaster}
            setFocusOnMount={false}
            onBlur={() => onNotesChange(outputId, outputNotes)} />

        </div>
        <div className="social-iteration__configure__footer">
          {isMobile &&
          <Button
            prefix={<LucideIcon icon={Trash2} size={20} />}
            onClick={deleteOutput}
            type="TERTIARY"
            disabled={!canUpdateMaster} />}


          {isLastOutput && canUpdateVideo ?
          <div className="outputs-and-addons__social-iterations__header__action">
              <NewOutput
              disabled={!canUpdateMaster}
              onClick={createNewOutput} />

            </div> :
          null}
        </div>
      </div>
    </div>);

}

export default memo(SocialIteration);